'use es6';

import { Layer } from 'reporting-visualizations/visualizations/xy/xyRecords';
import { XYVisualization } from 'reporting-visualizations/visualizations/xy/xyRecords';
import { isTimeSeries, getDateLineInfo, getMetricField, getBucketField, getBreakdownField, isWeightedPipelineReport } from '../lib/salesAnalytics/helpers';
import { SLINKY, OLAF, CHART_BLUE } from 'reporting-visualizations/constants/hubStyleTokensColors';
export const forecastManualSubmissionLayer = report => {
  const bucketField = getBucketField(report);
  return Layer({
    dataset: 'quota',
    mark: {
      type: 'line',
      dashStyle: 'ShortDash',
      marker: {
        fillColor: OLAF,
        lineColor: CHART_BLUE,
        lineWidth: 2,
        radius: 3.5,
        symbol: 'circle'
      },
      stacking: true
    },
    color: {
      default: CHART_BLUE
    },
    x: {
      field: bucketField,
      type: 'category',
      blend: 'bottom'
    },
    y: {
      field: 'forecastAmount',
      type: 'linear',
      blend: 'left'
    }
  });
};
const getAccumulatedQuotaLayer = bucketField => {
  return Layer({
    dataset: 'quota',
    mark: {
      type: 'line',
      dashStyle: 'ShortDash',
      marker: {
        lineColor: SLINKY,
        fillColor: OLAF,
        lineWidth: 2
      }
    },
    color: {
      default: SLINKY
    },
    x: {
      field: bucketField,
      type: 'category',
      blend: 'bottom'
    },
    y: {
      field: 'accumulatedQuota',
      type: 'linear',
      blend: 'left'
    }
  });
};
export const IntraPeriodVisualization = ({
  report,
  data
}) => {
  const bucketField = getBucketField(report);
  const metric = getMetricField(report);
  const breakDownField = getBreakdownField(report);
  return XYVisualization({
    type: 'XY',
    data: {
      primary: data.getIn(['primary', 'data']),
      quota: data.getIn(['quota', 'data'])
    },
    layers: [Layer({
      dataset: 'primary',
      mark: Object.assign({
        type: 'line',
        dashStyle: 'shortDash',
        marker: {
          enabled: false
        }
      }, isWeightedPipelineReport(report) ? {
        stacking: true,
        stack: 'DEFAULT_STACK'
      } : {}),
      x: {
        field: bucketField,
        type: 'category',
        blend: 'bottom'
      },
      y: {
        field: `SUM|${metric}`,
        type: 'linear',
        blend: 'left'
      },
      color: {
        field: breakDownField,
        order: isWeightedPipelineReport(report) ? {
          direction: 'ascending',
          field: `dealstage.probability`
        } : {
          direction: 'descending',
          field: `SUM|${metric}`
        }
      }
    }), getAccumulatedQuotaLayer(bucketField)],
    style: Object.assign({
      type: 'line'
    }, getDateLineInfo(data.getIn(['primary', 'data', 'data']), 'closedate'))
  });
};
export const quotaViz = report => {
  const bucketField = report.getIn(['config', 'dimensions', 0]);
  if (isTimeSeries(report)) {
    return Layer({
      dataset: 'quota',
      mark: {
        type: 'tick',
        dashStyle: 'ShortDash',
        marker: {
          lineColor: SLINKY,
          fillColor: OLAF,
          lineWidth: 2
        }
      },
      color: {
        default: SLINKY
      },
      x: {
        field: bucketField,
        type: 'category',
        blend: 'bottom'
      },
      y: {
        field: 'quotaAmount',
        type: 'linear',
        blend: 'left'
      }
    });
  }
  return Layer({
    dataset: 'quota',
    mark: {
      type: 'tick',
      dashStyle: 'shortDash',
      marker: {
        lineColor: SLINKY,
        lineWidth: 2
      }
    },
    color: {
      default: SLINKY
    },
    x: {
      field: 'quotaAmount',
      type: 'linear',
      blend: 'left'
    },
    y: {
      field: bucketField,
      type: 'category',
      blend: 'bottom'
    }
  });
};
export const forecastViz = report => {
  const bucketField = report.getIn(['config', 'dimensions', 0]);
  if (isTimeSeries(report)) {
    return Layer({
      dataset: 'quota',
      mark: {
        type: 'scatter',
        marker: {
          fillColor: OLAF,
          lineColor: CHART_BLUE,
          lineWidth: 2,
          radius: 3.5,
          symbol: 'circle'
        },
        stacking: false
      },
      color: {
        default: CHART_BLUE
      },
      x: {
        field: bucketField,
        type: 'category',
        blend: 'bottom'
      },
      y: {
        field: 'forecastAmount',
        type: 'linear',
        blend: 'left'
      }
    });
  }
  return Layer({
    dataset: 'quota',
    mark: {
      type: 'scatter',
      marker: {
        fillColor: OLAF,
        lineColor: CHART_BLUE,
        lineWidth: 2,
        radius: 3.5,
        symbol: 'circle'
      },
      stacking: false
    },
    color: {
      default: CHART_BLUE
    },
    x: {
      field: 'forecastAmount',
      type: 'linear',
      blend: 'left'
    },
    y: {
      field: bucketField,
      type: 'category',
      blend: 'bottom'
    }
  });
};